<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/lead">Leads</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo lead</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Nome*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                        v-model="lead.name">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">E-mail*</label>
                                    <input type="text" class="form-control" placeholder="Ex: usurio@dominio.com"
                                        v-model="lead.email">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Telefone*</label>
                                    <input type="text" class="form-control" v-model="lead.phone"
                                        v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(xx)x.xxxx-xxxx">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">CEP</label>

                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                            v-model="lead.zipcode" v-mask="['#####-###']">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" id="button-addon2"
                                                @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                CEP</button>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-xl-7 col-md-7 col-sm-12">
                                    <label for="">Endereço*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                        v-model="lead.street">
                                </div>
                                <div class="col-xl-2 col-md-2 col-sm-12">
                                    <label for="">Nº</label>
                                    <input type="text" class="form-control" placeholder="Ex: 100"
                                        v-model="lead.number_street">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Complemento</label>
                                    <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                        v-model="lead.complement">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Bairro</label>
                                    <input type="text" class="form-control" placeholder="Ex: Centro"
                                        v-model="lead.district">
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Cidade</label>
                                    <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                        v-model="lead.city">
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">UF</label>
                                    <input type="text" class="form-control" placeholder="Ex: SP" v-model="lead.uf">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Serviço</label>
                                    <input type="text" class="form-control" placeholder="Ex: Consultoria contábil"
                                        v-model="lead.service" @keypress="searchService()">
                                    <ul class="autocomplete-list">
                                        <li class="list-item pointer" v-for="(result, index) in results" :key="index"
                                            @click="selectedService(result.name)">{{ result.name }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Vendedor(a)</label>
                                    <input type="text" class="form-control" placeholder="Ex: Maria"
                                        v-model="lead.seller">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Valor médio</label>
                                    <input type="text" class="form-control" placeholder="R$ 0,00"
                                        v-model.lazy="lead.amount" v-money="money">
                                </div>
                            </div>
                            <div class="row mb-4 mt-3">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText @update-text="updateObservation" :modelValue="lead.observation"
                                        placeholderSend="Sem observações" ref="myChild">
                                    </editorText>
                                </div>
                            </div>
                            <br><br>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                    <router-link to="/lead" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import { loadZipcode } from '@/api-external';
import { VMoney } from 'v-money'


export default {
    directives: { mask, money: VMoney },
    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            results: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            lead: {
                name: '',
                email: '',
                phone: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                seller: '',
                service: '',
                amount: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.lead.name != '' && this.lead.email != '' && this.lead.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API

    },
    methods: {
        onCancel() { },
        searchZipcode() {

            if (this.lead.zipcode.length > 0) {
                this.isLoading = true;
                let zipcode = this.lead.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.lead.street = response.street;
                    this.lead.district = response.neighborhood;
                    this.lead.city = response.city;
                    this.lead.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.isLoading = true;
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        updateObservation(observation) {
            this.lead.observation = observation;
        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/lead', this.lead)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Lead cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.lead = {};
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        },
        searchService() {
            if (this.lead.service.length > 3) {
                this.enable_error_list = false;
                api.get('/search-service', { params: { 'search': this.lead.service } })
                    .then((response) => {
                        const result_response = response.data.search;
                        result_response.forEach(service => {
                            this.results.push({
                                'name': service.name,

                            })

                        });
                    }).catch(error => {
                        handleRequestErrors(error.status, error);
                    })
            }
        },
        selectedService(service_selected) {
            this.lead.service = this.lead.service + ' ' + service_selected;
            this.results = [];
        }
    }
}
</script>

<style>
.autocomplete-list {
    position: absolute;
    list-style-type: none;
    background: #fff;
    width: 100%;
    margin-top: 50px;
    box-shadow: 0 0 10px #ddd;
    background: #e9e9e9;
    transition: all 300ms ease-out;
    transform: scale(1) translateY(0);
    transform-origin: center center;
    z-index: 99999;
    max-height: 300px;
    overflow-y: auto;
}

.list-item {
    padding: 10px;
    border-top: 1px solid #0000001f;
    background: #e9e9e9;
}

.list-item:hover {
    background: #d8d8d8;
}

.pointer {
    cursor: pointer;
}
</style>